import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { DeleteConfirmDialog } from '../../../../../../components-v2/DeleteConfirmDialog';
import { styleSheet } from './styles';

type IProps = {
	file: Api.ISharedFile | null;
	isDeleting: boolean;
	onClose: () => void;
	onConfirm: () => void;
};

export const DeleteFileConfirmModal = ({ file, isDeleting, onClose, onConfirm }: IProps) => {
	return (
		<DeleteConfirmDialog
			open={file !== null}
			title='Delete file?'
			description={
				<>
					Are you sure you want to delete <strong>{file?.fileAttachment.fileName}</strong> from this contact?
					<span className={css(styleSheet.undoneLine)}>This action cannot be undone.</span>
				</>
			}
			isDeleting={isDeleting}
			onClose={onClose}
			onConfirm={onConfirm}
		>
			{file?.isProtected && (
				<div className={css(styleSheet.warningBanner)}>
					This file is also used elsewhere, like in a template or automation, so it won&apos;t be deleted from our
					servers — only its link to this contact will be removed.
				</div>
			)}
		</DeleteConfirmDialog>
	);
};
